/**
 * LUNE — Interface (vanilla JS, sans framework).
 * Construit la bulle + le panneau de conversation, restitue les messages émis
 * par Lune.Conversation, gère le clavier (Échap, clic extérieur), le focus et
 * le verrou de scroll. Tout le texte est inséré via textContent (jamais
 * innerHTML) : aucune donnée, y compris ce que tape le client, n'est jamais
 * interprétée comme du HTML.
 */
(function () {
  'use strict';

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  // Le filtre `json` de Liquid rend `null` pour un metafield liste non renseigné
  // (pas `[]`) : on normalise ici pour que le moteur de scoring reste simple.
  function normalizeCatalog(catalog) {
    return catalog.map(function (p) {
      p.room = p.room || [];
      p.style = p.style || [];
      p.colors = p.colors || [];
      p.intensity = p.intensity || '';
      return p;
    });
  }

  function init(root) {
    var knowledge = readJSON('lune-knowledge-data');
    var catalog = normalizeCatalog(readJSON('lune-catalog-data') || []);
    var pageContext = readJSON('lune-page-context-data') || {};
    var copy = readJSON('lune-copy-data') || {};

    if (!knowledge) return;

    var bubble = root.querySelector('[data-lune-bubble]');
    var panel = root.querySelector('[data-lune-panel]');
    var closeBtn = root.querySelector('[data-lune-close]');
    var messagesEl = root.querySelector('[data-lune-messages]');
    var form = root.querySelector('[data-lune-form]');
    var input = root.querySelector('[data-lune-input]');

    var session = Lune.Conversation.createSession({
      knowledge: knowledge,
      catalog: catalog,
      pageContext: pageContext,
      copy: copy
    });

    var started = false;
    var lastFocused = null;

    session.subscribe(renderMessages);

    function renderMessages(messages) {
      messages.forEach(renderMessage);
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }

    function renderMessage(message) {
      if (message.type === 'bot_text') {
        var lines = message.text.split('\n');
        var bubbleEl = el('div', 'lune-msg lune-msg--bot');
        lines.forEach(function (line, i) {
          if (i > 0) bubbleEl.appendChild(document.createElement('br'));
          bubbleEl.appendChild(document.createTextNode(line));
        });
        messagesEl.appendChild(bubbleEl);
      } else if (message.type === 'user_text') {
        messagesEl.appendChild(el('div', 'lune-msg lune-msg--user', message.text));
      } else if (message.type === 'bot_link') {
        var link = document.createElement('a');
        link.className = 'lune-msg lune-msg--link';
        link.href = message.url;
        link.textContent = message.label + ' →';
        messagesEl.appendChild(link);
      } else if (message.type === 'bot_buttons') {
        messagesEl.appendChild(renderButtons(message.buttons));
      } else if (message.type === 'bot_cards') {
        messagesEl.appendChild(renderCards(message.cards));
      }
    }

    function renderButtons(buttons) {
      var group = el('div', 'lune-options');
      buttons.forEach(function (btn) {
        var b = el('button', 'lune-option', btn.label);
        b.type = 'button';
        b.addEventListener('click', function () {
          group.remove();
          session.sendButton(btn.action, btn.payload, btn.label);
        });
        group.appendChild(b);
      });
      return group;
    }

    function renderCards(cards) {
      var wrap = el('div', 'lune-cards');
      cards.forEach(function (card) {
        var c = el('article', 'lune-card');

        if (card.image) {
          var imgWrap = el('div', 'lune-card__media');
          var img = document.createElement('img');
          img.src = card.image;
          img.alt = '';
          img.loading = 'lazy';
          imgWrap.appendChild(img);
          c.appendChild(imgWrap);
        }

        var body = el('div', 'lune-card__body');
        if (card.eyebrow) body.appendChild(el('p', 'lune-card__eyebrow', card.eyebrow));
        body.appendChild(el('p', 'lune-card__title', card.title));
        if (card.reason) body.appendChild(el('p', 'lune-card__reason', card.reason));

        var ctas = el('div', 'lune-card__ctas');
        [card.primaryCta, card.secondaryCta].forEach(function (cta) {
          if (!cta) return;
          if (cta.url) {
            var a = document.createElement('a');
            a.className = cta === card.primaryCta ? 'lune-card__cta lune-card__cta--primary' : 'lune-card__cta';
            a.href = cta.url;
            a.textContent = cta.label;
            a.addEventListener('click', function () {
              session.sendButton(cta.action, cta.payload);
            });
            ctas.appendChild(a);
          }
        });
        if (ctas.childNodes.length) body.appendChild(ctas);

        c.appendChild(body);
        wrap.appendChild(c);
      });
      return wrap;
    }

    function openPanel() {
      panel.hidden = false;
      bubble.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('lune-scroll-lock');
      lastFocused = document.activeElement;
      if (!started) {
        started = true;
        session.start();
      }
      window.requestAnimationFrame(function () {
        input.focus();
      });
      document.addEventListener('keydown', onKeydown, true);
      document.addEventListener('click', onOutsideClick, true);
    }

    function closePanel() {
      panel.hidden = true;
      bubble.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('lune-scroll-lock');
      document.removeEventListener('keydown', onKeydown, true);
      document.removeEventListener('click', onOutsideClick, true);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      } else {
        bubble.focus();
      }
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        closePanel();
        return;
      }
      if (event.key === 'Tab') {
        trapFocus(event);
      }
    }

    function trapFocus(event) {
      var focusable = panel.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function onOutsideClick(event) {
      if (panel.hidden) return;
      if (panel.contains(event.target) || bubble.contains(event.target)) return;
      closePanel();
    }

    bubble.addEventListener('click', function () {
      if (panel.hidden) {
        openPanel();
      } else {
        closePanel();
      }
    });
    closeBtn.addEventListener('click', closePanel);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var text = input.value.trim();
      if (!text) return;
      input.value = '';
      session.sendText(text);
    });

    // CTA discret sur fiche produit (section 11 du brief) : "Demandez à LUNE".
    var pageCta = document.querySelector('[data-lune-page-cta]');
    if (pageCta) {
      pageCta.addEventListener('click', function (event) {
        event.preventDefault();
        openPanel();
        window.setTimeout(function () {
          session.sendButton('choose_finish', null, 'Choisir ma finition');
        }, 300);
      });
    }
  }

  function boot() {
    var root = document.querySelector('[data-lune-root]');
    if (!root) return;
    init(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
